<template>
  <div class="box">
    <div class="section">
      <!-- 网站标题区 -->
      <div class="header">
        <span class="d-flex ai-center">
          <img class="m-1" src="@/assets/logo.png" alt="" width="45" />
          <span class="ml-2">
            <div>舆情系统用户登录</div>
          </span>
        </span>
      </div>
      <div class="m-3">
        <router-view />
      </div>
    </div>
    <!-- <div class="footer">
      <el-row class="mt-3" type="flex" justify="center">
        <el-col :lg="19" :xs="24" class="d-flex ai-center foot-text">
          <span class="m-2 text-red fs-md">{{ SystemName }}</span>
          <span class="m-2 text-grey hidden-sm-and-down fs-md">{{
            MaintenanceUnitName
          }}</span>
        </el-col>
      </el-row>
    </div> -->
    
    <!-- <div class="foot mt-2">
      <div class="foot-text d-flex ai-center my-1">
        <span class="ml-2 text-grey">{{ MaintenanceUnitName }}</span>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Home",
  created() {
    document.title = "舆情管理系统";
    //console.log('home')
    // var token = this.appApi.getToken();
    //var userInfo = window.sessionStorage.getItem("userInfo");
    // var userInfo = this.appApi.getUserData();

    // if (token && userInfo && token.length > 0) {
    //   //var data = JSON.parse(userInfo);
    //   this.$store.commit("setUserInfo", userInfo);
    //   this.$router.push({ name: "MainFrame" });
    // }
  },

  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang='less' scoped>
.box {
  //background: url("../../assets/background.jpg") no-repeat;
  width: 100vw;
  height: 100vh;
  background-size: cover;
}
.foot-text {
  height: 25px;
}
</style>
